/* @ngInject */
const pieceGo = (
  $state,
  routes,
  wagonLocal
) => {
  const self = {}

  self.edit = (_id) => {
    wagonLocal.saveCurrentScrappedId(_id)
    $state.go(routes.scrapping.sale.pieces.path)
  }

  return self
}
export default pieceGo



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/services/go.service.js